import React, { useEffect, useState } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import headerKanan from './images/header-kanan.png';
import arrows from './images/arrows.png';

import './header.styles.css';
import './stars.styles.scss';

function Header() {
    const [offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div id="header" style={{ transform: `translateY(${offsetY * 0.3}px)` }}>
        <div id="stars"></div>
        <div id="stars2"></div>
        <div id="stars3"></div>
        <Container fluid className="header">
        <Row className="justify-content-center">
            <Col xl={true} className="header-left">
                <h1 id="title" className="big-title"><span>Gita P. <br />Sujatmiko</span></h1>
                {/* <h1 className="big-title-shadow">Gita P. <br />Sujatmiko</h1> */}
                <img src={arrows} alt="arrows" className="arrows" />
            </Col>
            <Col xl={true} className="header-right">
                <img src={headerKanan} alt="gps-header" draggable="false" className="header-kanan" />
            </Col>
        </Row>
        </Container>
        </div>
    );
}

export default Header;